// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "[data-v-5fb8729c] .el-dialog__body {\n  padding: 0.052083rem 0.104167rem 0.104167rem 0.104167rem;\n}", "",{"version":3,"sources":["D:/source/200xth/xth2.web/<input css 61>"],"names":[],"mappings":"AAAA;EACE,wDAAwD;AAC1D","file":"answerViewer.vue","sourcesContent":["/deep/.el-dialog__body {\n  padding: 0.052083rem 0.104167rem 0.104167rem 0.104167rem;\n}"]}]);
// Exports
module.exports = exports;
